import { Fragment } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, InputAdornment, TextField, Card } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import Pagination from "../../components/Pagination";
import SearchIcon from "@mui/icons-material/Search";
import PreviewIcon from "@mui/icons-material/Preview";
import {
  getSwaps,
  getUserSwaps,
  setSearchSwap,
  setUser,
  setUserSearchSwap,
} from "../../redux/actions/userAction";
import noTransactionImg from "../../assets/transaction_eth.png";

const ViewUserSwaps = ({ userId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const User = useSelector(({ User }) => User);
  const {
    userFilteredSwaps,
    userPaginatedSwaps,
    userCurrentSwapPage,
    userTotalSwapPages,
    userSwapPerPage,
    userSwapSearch,
  } = User;

  useEffect(() => {
    dispatch(getUserSwaps({ data: { userId } }));
    // eslint-disable-next-line
  }, []);

  const setTotalPages = (totalpages) => {
    dispatch(
      setUser({
        name: "userTotalSwapPages",
        value: totalpages,
      })
    );
  };
  const setCurrentPage = (currentPage) => {
    dispatch(
      setUser({
        name: "userCurrentPage",
        value: currentPage,
      })
    );
  };
  const setPaginatedItems = (paginatedItems) => {
    dispatch(
      setUser({
        name: "userPaginatedSwaps",
        value: paginatedItems,
      })
    );
  };
  const handleChangeRowsPerPage = (event) => {
    const value = event.target.value;
    dispatch(
      setUser({
        name: "swapPerPage",
        value,
      })
    );
  };

  const onSearch = (e) => {
    const value = e.target.value;
    dispatch(setUserSearchSwap(value));
  };

  const onViewSwap = (swap) => {
    dispatch(
      setUser({
        name: "selectedSwap",
        value: swap,
      })
    );
    navigate("/viewSwapDetail");
  };

  return (
    <Fragment>
      <div className="table-layout-container">
        <Card className="table-card">
          <div className="table-title">
            <span>List of Swaps</span>
            <div>
              <TextField
                fullWidth
                variant="standard"
                className="search-input"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon style={{ color: "white" }} />
                    </InputAdornment>
                  ),
                }}
                onChange={onSearch}
                value={userSwapSearch}
              />
            </div>
          </div>
          <div className="table-container">
            <table>
              <thead>
                <th>SwapId</th>
                <th>Amount Sent</th>
                <th>Amount Receive</th>
                <th>Status</th>
                <th>Date</th>
                <th>Action</th>
              </thead>
              <tbody>
                {userPaginatedSwaps?.length >= 1 &&
                  userPaginatedSwaps.map((swap) => {
                    const date = new Date(swap.date);
                    const day = date.getDate();
                    const month = date.getMonth() + 1;
                    const year = date.getFullYear();
                    const formattedDate = `${day}-${month}-${year}`;

                    return (
                      <Fragment>
                        <tr>
                          <td>{swap.swapId}</td>
                          <td>{`${swap.amountSent} ${swap.coinSent}`}</td>
                          <td>{`${swap.amountToRecieve} ${swap.coinRecieve}`}</td>
                          <td>{swap.status}</td>
                          <td>{formattedDate}</td>
                          <td>
                            <div className="action-row">
                              <Button
                                className="action-btn edit"
                                variant="contained"
                                onClick={() => onViewSwap(swap)}
                              >
                                {" "}
                                <PreviewIcon />
                                <span> View</span>
                              </Button>
                            </div>
                          </td>
                        </tr>
                      </Fragment>
                    );
                  })}
              </tbody>
            </table>
            {userPaginatedSwaps?.length < 1 && (
              <Fragment>
                <div className="no-transaction-container">
                  <img
                    src={noTransactionImg}
                    className="no-transaction-img"
                    alt="no-transaction-img.png"
                  />
                  <div className="no-transaction-text">No Swaps Found</div>
                </div>
              </Fragment>
            )}
          </div>
          <Pagination
            currentPage={userCurrentSwapPage}
            setCurrentPage={setCurrentPage}
            items={userFilteredSwaps}
            totalPages={userTotalSwapPages}
            setTotalPages={setTotalPages}
            itemsPerPage={userSwapPerPage}
            setPaginatedItems={setPaginatedItems}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
          <Loader />
        </Card>
      </div>
    </Fragment>
  );
};

export default ViewUserSwaps;
